export var ElasticFilterType;
(function (ElasticFilterType) {
    ElasticFilterType["Bool"] = "bool";
    ElasticFilterType["Range"] = "range";
    ElasticFilterType["Exists"] = "exists";
    ElasticFilterType["MatchPhrase"] = "match_phrase";
    ElasticFilterType["Match"] = "match";
    ElasticFilterType["QueryString"] = "query_string";
    // Custom filters
    ElasticFilterType["Lookup"] = "lookup";
})(ElasticFilterType || (ElasticFilterType = {}));
export var KibanaFilterType;
(function (KibanaFilterType) {
    KibanaFilterType["Phrase"] = "phrase";
    KibanaFilterType["Phrases"] = "phrases";
    KibanaFilterType["Range"] = "range";
    KibanaFilterType["Exists"] = "exists";
    KibanaFilterType["Match"] = "match";
    KibanaFilterType["Query"] = "query";
    // Custom filters
    KibanaFilterType["Lookup"] = "lookup";
})(KibanaFilterType || (KibanaFilterType = {}));
//# sourceMappingURL=filter-interfaces.js.map